<template>
    <div class="appPage" ref="videoRoll">
        <div class="box1 top_box">
            <img src="../assets/team_title1.png" class="team_title1" />
            <div class="title">{{ team.title }}</div>
            <div class="content">{{ team.content }}</div>
            <div class="name">教练：{{ team.name }}</div>
            <div class="name1">领队：{{ team.name1 }}</div>
            <img class="img" :src="team.img" alt="">
        </div>
        <img src="../assets/team_title2.png" class="team_title2" />
        <div class="box1 bottom_box">
            <div class="team_view">
                <img class="img" style="width: 97%;margin: 0 auto;" :src="team.img1" alt="">
            </div>
        </div>

        <Back :linkTo="'/'" />
    </div>
</template>

<script>
export default {
    name: 'team',
    data () {
        return {
            ossLink: 'https://oss.eventnet.cn/H5/kwaiPlay/',
            team: []
        };
    },
    created () {
        const THAT = this;
        THAT.videoSet();
    },
    mounted () {
        const THAT = this;
        THAT.$refs.videoRoll.scrollTop = 0;
    },
    methods: {
        videoSet () {
            const THAT = this;
            THAT.axios.get('https://oss.eventnet.cn/H5/kwaiPlay/img1/request1.json?v=' + new Date().getTime()).then(
                res => {
                    THAT.team = res.team[THAT.$route.query.index];
                }).catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.appPage {
    // min-height: 100vh;
    background: url('../assets/bg.jpg') no-repeat;
    background-size: 100%;
    background-position: center bottom;
    padding-top: 100px;
    padding-bottom: 150px;
    font-style: italic;
    // min-height: 2981px;

    img.img {
        display: block;
        width: 100%;
    }

    .top_box {
        font-family: font;
        color: #717171;
        text-align: left;
        padding: 20px 32px 70px;

        .team_title1 {
            margin-top: -70px;
            margin-bottom: 60px;
        }

        .content {
            font-size: 26px;
            padding-bottom: 25px;
            text-align: justify;
        }

        .name1,
        .name {
            font-size: 30px;
            line-height: 1;
            padding-bottom: 20px;
        }

        .title {
            font-size: 48px;
            color: #fc591b;
            line-height: 1;
            padding-bottom: 25px;
        }
    }

    .bottom_box {
        padding: 20px 0;
    }

    .box1 {
        margin: 0 auto 60px;

        width: 660px;
        min-height: 100px;
        border: 8px solid #fc591b;
        border-right-color: #2945d4;
        position: relative;
        background: #fff;

        &::before {
            content: '';
            display: block;
            width: 338px;
            height: 8px;
            background: #2945d4;
            position: absolute;
            right: -8px;
            top: -8px;
        }

        &::after {
            content: '';
            display: block;
            width: 338px;
            height: 8px;
            background: #2945d4;
            position: absolute;
            right: -8px;
            bottom: -8px;
        }

        .team_view {
            background: #fc591b;
            width: 625px;
            margin: 0 auto;
            padding: 15px 0;

            .right {
                width: 320px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: #3a3a3a;
                flex: 1;

                p:first-child {
                    font-size: 20px;
                }

                p:last-child {
                    font-size: 14px;
                }
            }

            .videoBox {
                width: 595px;
                height: 97px;
                margin: 0 auto 15px;
                overflow: hidden;
                display: flex;
                align-items: center;
                position: relative;
                background: url(../assets/team_bg1.png) no-repeat;
                background-position: right;
                background-size: auto 100%;

                &:last-child {
                    margin: 0 auto;
                }

                .name {
                    position: absolute;
                    font-size: 25px;
                    right: 350px;
                    text-align: right;
                }

                img {
                    width: 325px;
                }
            }
        }

    }

    .team_title1,
    .team_title2 {
        display: block;
        margin: 0 auto 20px;
        width: 330px;
        position: relative;
        z-index: 1;
    }
}
</style>